import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import Stack from "@mui/material/Stack";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { CopyIconButton } from "@/components/common/CopyIconButton";
import { useHover } from "@/utils/hooks/useHover.hook";
import { underutilizedSavingOpportunitiesDescription } from "@/components/pages/savings-opportunities/utils/constants/common";
import { kubernetesResourceTypes } from "@/store/resources-grid/utils/constants/common";
import { AiKubernetesRecommendationsDescriptionCell } from "@/components/pages/ai-kubernetes-recommendations/components/AiKubernetesRecommendationsDescriptionCell";

export const SavingsOpportunityDescriptionCellRenderer: FC<
  CustomCellRendererProps<SavingsOpportunity>
> = ({ data }) => {
  const { ref, hovered } = useHover();
  const isKubernetes =
    !!data?.service && kubernetesResourceTypes.has(data?.service);

  let description = data?.description ?? "";

  if (data?.action_type === "live_filtered_resource") {
    description = underutilizedSavingOpportunitiesDescription;
  }

  if (isKubernetes) {
    return (
      <AiKubernetesRecommendationsDescriptionCell description={description} />
    );
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" ref={ref}>
      <TypographyWithTooltip
        title={description}
        variant="body2"
        tooltipMaxHeight="38dvh"
        placement="bottom"
      >
        {description}
      </TypographyWithTooltip>

      {description && (
        <CopyIconButton
          data-block-row-click
          data={description}
          visible={hovered}
          TooltipProps={{ placement: "top" }}
        />
      )}
    </Stack>
  );
};
